export const SECTION_DIVIDER_HEIGHTS = { mobile: 60, tablet: 80, desktop: 120 };
export type SectionDividerType = 'high-left' | 'high-right' | 'polygon';
